import { api } from "./apiClient";

export const documentService = {
  async declare({ kind, document_number, note }) {
    const { data } = await api.post("/documents", { kind, document_number, note });
    return data;
  },
  async mine() {
    return (await api.get("/documents/mine")).data;
  },
  async adminList(params) {
    return (await api.get("/admin/documents", { params })).data;
  },
  async review(id, status, review_note) {
    return (await api.patch(`/admin/documents/${id}`, { status, review_note })).data;
  },
};
